import React, { useState, useEffect, forwardRef } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";

import AccessibleIcon from "@mui/icons-material/Accessible";

import instance, { getErrorMessage } from "api/definitions";

const sortListByLabel = (currentList) => {
  const newList = [...currentList].sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
  return newList;
};

const SelectResource = forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [resource, setResource] = useState([]);
  const [errorResource, setErrorResource] = useState(null);

  const handleChange = (event, newValue) => {
    setResource(newValue);

    props.parentCallback(newValue);
  };

  useEffect(() => {
    setResource(props.dataParentToChild);
    setErrorResource(props.errorParentToChild);

    instance
      .get("recurso")
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        const resources = [];
        result.map((item) =>
          resources.push({ label: item.nome, id: item.id, pcd: item.pcd })
        );
        setItems(sortListByLabel(resources));
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        setError(msg);
      });
  }, [props.dataParentToChild, props.errorParentToChild]);

  if (error) {
    return <div>Erro: {error}</div>;
  } else if (!isLoaded) {
    return <CircularProgress />;
  } else {
    return (
      <Autocomplete
        disableClearable
        disabled={props.disabled && props.disabled}
        value={resource}
        onChange={handleChange}
        disablePortal
        id="resource"
        options={items}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) =>
          value === undefined ||
          value === "" ||
          option.id === value.id ||
          option.nome === value.nome
        }
        noOptionsText={"Nenhum cadastrado"}
        renderInput={(params) => (
          <TextField
            {...params}
            autoFocus={props.autoFocus && props.autoFocus}
            fullWidth
            margin="dense"
            inputRef={ref}
            error={errorResource}
            label="Recurso"
          />
        )}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box key={key} component="li" {...optionProps}>
              {option.label}{" "}
              {option.pcd === "1" && (
                <AccessibleIcon sx={{ color: "primary.main" }} />
              )}
            </Box>
          );
        }}
      />
    );
  }
});

export default SelectResource;
